export enum ConnectorCategory {
  Lock = "Lock",
  Hinge = "Hinge",
}
